module.exports = __webpack_public_path__ + "static/media/edenred.d3261139.svg";